import React from "react"
import ChipSwitch from "../../../../../ui/molecules/ChipSwitch"
import { useAlgoliaSearchState } from "../../controller/state"
import { AlgoliaCheckboxOption } from "../../controller/state/types"

interface Props {
  item: AlgoliaCheckboxOption
}

export const SwitchFilterChip = ({ item }: Props) => {
  const { updateSearchParams } = useAlgoliaSearchState()

  const toggle = () => {
    updateSearchParams((state) => {
      if (!state.switch) {
        state.switch = new Map<string, string>()
      }
      if (item.selected) {
        state.switch?.delete(item.key)
      } else {
        state.switch?.set(item.key, item.value)
      }
      return state
    })
  }

  return (
    <div className="mb-2 mr-2">
      <ChipSwitch
        label={item.label}
        value={item.selected}
        onChange={() => toggle()}
        disabled={item.disabled}
      />
    </div>
  )
}
